import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/NavbarAuth.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/OnboardingBanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AuthProvider"] */ "/vercel/path0/src/components/providers/AuthProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["UserProvider"] */ "/vercel/path0/src/components/providers/UserProvider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider"] */ "/vercel/path0/src/components/ui/Toast.tsx");
